import script from "./ToolResultMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolResultMessage.vue?vue&type=script&setup=true&lang=js"

import "./ToolResultMessage.vue?vue&type=style&index=0&id=632e9d0d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632e9d0d"]])

export default __exports__